
  export default {
    props: {
      inputAttrs: { type: Object, default () { return {}; } },
      field: { type: String, required: true },
      required: { type: Boolean, default: false },
      value: { type: null, required: true }
    },
    computed: {
      attribute: {
        get () {
          if (this.value && this.value.match(/\d{4}-\d{2}-\d{2}$/)) {
            return this.$dateTime(this.value, 'shortDate');
          }
          return this.value;
        },
        set (val) {
          this.$emit('input', val);
          if (this.$el) {
            this.validate(val);
          }
        }
      },
      formErrors () {
        return this.$store.getters['utils/formErrors'];
      }
    },
    methods: {
      validate (val) {
        if (val.length === 0) return;

        const input = this.$el.querySelector('input');
        let error = '';
        const max = parseInt(this.inputAttrs['date-max']);
        const min = parseInt(this.inputAttrs['date-min']);

        // check if the date format is valid
        if (!val.match(/\d{2}\/\d{2}\/\d{4}/)) {
          error = this.$t('errors.dateFormat');
        } else {
          const [d, m, y] = val.split('/');
          const date = new Date(`${y}-${m}-${d}`);

          // check if the date is valid
          if (isNaN(date.getTime()) || date.getDate() !== parseInt(d)) {
            error = this.$t('errors.dateInvalid');
          } else if (!isNaN(max) && date.getTime() > max) {
            error = this.$t('errors.dateAfterMax', [this.$dateTime(max, 'shortDate')]);
          } else if (!isNaN(min) && date.getTime() < min) {
            error = this.$t('errors.dateBeforeMin', [this.$dateTime(min, 'shortDate')]);
          }
        }

        input.setCustomValidity(error);
        input.reportValidity();
      }
    }
  };
